import joeyImg from '../images/team/joey.png';
import johnImg from '../images/team/john.jpg';

export const team = [
  { id: 1, name: 'Joey Russo', role: 'Foreman', image: joeyImg },
  { id: 2, name: 'John Russo', role: 'Operator', image: johnImg },
];
